import { render, staticRenderFns } from "./staffLogin.vue?vue&type=template&id=bf9b5766&scoped=true"
import script from "./staffLogin.vue?vue&type=script&lang=js"
export * from "./staffLogin.vue?vue&type=script&lang=js"
import style0 from "./staffLogin.vue?vue&type=style&index=0&id=bf9b5766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9b5766",
  null
  
)

export default component.exports